import React from 'react'

const EditIcon = (props) => {
    return (
  <svg width={30} height={30} fill="none" {...props}>
    <rect width={30} height={30} fill="#fff" rx={3} />
    <path
      fill="#8790A4"
      d="M19.354 7.646a.5.5 0 0 0-.707 0l-1.999 1.999-.002.001c0 .001 0 .002-.002.002l-7.998 7.998a.5.5 0 0 0-.131.233l-1 4a.5.5 0 0 0 .606.606l4-1a.501.501 0 0 0 .233-.131l8-8 2-2a.5.5 0 0 0 0-.708l-3-3ZM20 12.293 21.293 11 19 8.707 17.707 10 20 12.293Zm-3-1.586L19.293 13l-7.549 7.549-3.057.764.764-3.057L17 10.707Z"
    />
  </svg>
    )
}

export default EditIcon